
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interviews",
      function () {
        return require("private-next-pages/interviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interviews"])
      });
    }
  